import { BaseAttributeWrapper } from "./Attribute";

export default class SpreadAttributeWrapper extends BaseAttributeWrapper {}
